'use client';

import { KeyboardEvent, MouseEvent, ReactNode, createContext } from 'react';
import { DeliveryType } from '@/features/enums/DeliveryType';
import type { CompleteVenueWithGeoData } from '@/features/venue-router';
import { Address } from '@/shared/model/Address';
import { Optional } from '@/shared/model/Optional';

type VenueContextValue = {
    data: Optional<CompleteVenueWithGeoData, 'distance'>;
    href?: string;
    deliveryType?: DeliveryType | null;
    address?: Address | null;
    onClick?(e: MouseEvent): void;
    onKeyDown?(e: KeyboardEvent): void;
};

export const VenueContext = createContext<VenueContextValue | null>(null);

type Props = {
    value: VenueContextValue;
    children?: ReactNode;
};

export const VenueProvider = ({ value, children }: Props) => {
    return <VenueContext.Provider value={value}>{children}</VenueContext.Provider>;
};
